import { render, staticRenderFns } from "./OperaSubDistrictOfficeDataWindow.vue?vue&type=template&id=54befcc3&scoped=true"
import script from "./OperaSubDistrictOfficeDataWindow.vue?vue&type=script&lang=js"
export * from "./OperaSubDistrictOfficeDataWindow.vue?vue&type=script&lang=js"
import style0 from "./OperaSubDistrictOfficeDataWindow.vue?vue&type=style&index=0&id=54befcc3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54befcc3",
  null
  
)

export default component.exports